import { useContext } from 'react';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import _noop from 'lodash/noop';
import _get from 'lodash/get';

type Action = {
	id: string;
	isEnabled: () => boolean;
	name: string;
};

type ActionHandlerParams = {
	history: any;
	rowData: any;
};

export const makeActionHandler = (pageName: string, entityName: string) => (action: Action, params: ActionHandlerParams) => {
	const { history, rowData = EMPTY_OBJECT } = params;
	const { showAlert } = useContext(AppContext);

	const oldObject = _get(rowData, ['oldObject']);
	const newObject = _get(rowData, ['newObject']);

	switch (action.id) {
		case 'showChanges':
			return () => {
				history.push({
					pathname: `/${pageName}/${entityName}/showChanges`,
					state: {
						rowData
					}
				});
			};
		case 'copyOldObject':
			return () => {
				navigator.clipboard.writeText(JSON.stringify(oldObject, null, 2));
				showAlert('Copied');
			};
		case 'copyNewObject':
			return () => {
				navigator.clipboard.writeText(JSON.stringify(newObject, null, 2));
				showAlert('Copied');
			};

		default:
			return _noop;
	}
};

export default {
	makeActionHandler
};
